/**
 * 🧱 Refactor BT Phase 3 — Étape 2 : section « SectionEquipementsLocation » d'EditerBonTravailDialog.jsx.
 * JSX déplacé TEL QUEL (ex-L1966-2579, dédenté de 10) ; variables lues via `useBTForm()`
 * (BTFormProvider enrichi par `extra` dans le composant parent). DOM, data-testid, classes, textes inchangés.
 */
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Wrench } from 'lucide-react';
import { useBTForm } from '../../BTFormContext';

export function SectionEquipementsLocation() {
  const {
    alerteNacelle,
    alerteVehicules,
    clientsListe,
    form,
    isExt,
    loadingClients,
    loadingVehicules,
    nacellesDisponibles,
    setForm,
    type,
    typesEchafauds,
    vehiculesLivraison,
  } = useBTForm();
  return (
    <>
      {/* ═══════════════════════════════════════════════════════════════════ */}
      {/* ÉQUIPEMENTS DE LOCATION - REFACTORISÉ (Phases 2-5) */}
      {/* ═══════════════════════════════════════════════════════════════════ */}
      {isExt && (
        <Card>
          <CardHeader>
            <CardTitle className="text-base flex items-center gap-2">
              <Wrench className="w-5 h-5" />
              Équipements de location
            </CardTitle>
            <p className="text-xs text-slate-500 mt-1">
              Gérer les nacelles et échafauds nécessaires pour ce chantier
            </p>
          </CardHeader>
          <CardContent className="space-y-6">
      
            {/* ───────────────────────────────────────────────────────────── */}
            {/* PHASE 3: WORKFLOW NACELLE AVANCÉ */}
            {/* ───────────────────────────────────────────────────────────── */}
            <div className="border-2 border-cyan-200 rounded-lg p-4 bg-cyan-50/30">
              <label className="flex items-center gap-3 cursor-pointer group">
                <input
                  type="checkbox"
                  checked={form.equipements_nacelle_requise || false}
                  onChange={(e) => {
                    setForm(f => ({
                      ...f,
                      equipements_nacelle_requise: e.target.checked,
                      equipements_nacelle_dates: e.target.checked ? f.equipements_nacelle_dates : [],
                      equipements_nacelle_retour_type: 'bureau'
                    }));
                  }}
                  className="w-5 h-5 rounded border-cyan-300 text-cyan-600 focus:ring-cyan-400"
                />
                <div className="flex-1">
                  <span className="text-base font-semibold text-cyan-900 group-hover:text-cyan-700">
                    🏗️ Utilisation de la nacelle requise
                  </span>
                  <p className="text-xs text-cyan-700 mt-0.5">
                    Réserver une nacelle pour ce chantier
                  </p>
                </div>
              </label>

              {form.equipements_nacelle_requise && (
                <div className="mt-4 space-y-4 pl-8">
                  {/* ✅ Nacelle assignée automatiquement */}
                  <div className="flex items-center gap-2 p-3 bg-white border border-cyan-300 rounded-md">
                    <span className="text-sm font-medium text-cyan-900">
                      🏗️ Nacelle assignée : 
                      <span className="ml-2 font-semibold text-cyan-700">
                        {nacellesDisponibles.find(n => n.id === form.equipements_nacelle_id)?.nom || 'Aucune disponible'}
                        {nacellesDisponibles.find(n => n.id === form.equipements_nacelle_id)?.numero_unite && 
                          ` #${nacellesDisponibles.find(n => n.id === form.equipements_nacelle_id).numero_unite}`
                        }
                      </span>
                    </span>
                  </div>
                  {nacellesDisponibles.length === 0 && (
                    <p className="text-xs text-amber-600 italic">
                      ⚠️ Aucune nacelle configurée dans l'inventaire
                    </p>
                  )}

                  {/* ✅ PHASE 1 & 2: OPTIONS DE LIVRAISON */}
                  {form.equipements_nacelle_id && form.dates_chantier.length > 0 && (
                    <div className="border-2 border-indigo-200 rounded-lg p-3 bg-indigo-50/40">
                      <p className="text-sm font-semibold text-indigo-900 mb-3 flex items-center gap-2">
                        🚚 Options de livraison
                      </p>
                
                      {/* Radio buttons: Veille vs Jour J */}
                      <div className="space-y-2 mb-3">
                        <label className="flex items-center gap-2 cursor-pointer group">
                          <input
                            type="radio"
                            name="nacelle_livraison_timing"
                            value="jour_j"
                            checked={form.equipements_nacelle_livraison_timing === 'jour_j'}
                            onChange={() => setForm(f => ({ 
                              ...f, 
                              equipements_nacelle_livraison_timing: 'jour_j',
                              equipements_nacelle_vehicule_livraison_id: null,
                              equipements_nacelle_vehicule_livraison_nom: null
                            }))}
                            className="text-indigo-600"
                          />
                          <span className="text-sm group-hover:text-indigo-700">📅 Livrer le jour J (premier jour d'utilisation)</span>
                        </label>
                  
                        <label className="flex items-center gap-2 cursor-pointer group">
                          <input
                            type="radio"
                            name="nacelle_livraison_timing"
                            value="veille"
                            checked={form.equipements_nacelle_livraison_timing === 'veille'}
                            onChange={() => setForm(f => ({ ...f, equipements_nacelle_livraison_timing: 'veille' }))}
                            className="text-indigo-600"
                          />
                          <span className="text-sm group-hover:text-indigo-700">🌙 Livrer la veille</span>
                        </label>
                      </div>

                      {/* Sélecteur de véhicule si livraison la veille */}
                      {form.equipements_nacelle_livraison_timing === 'veille' && (
                        <div className="mt-3 space-y-2">
                          <label className="text-sm font-medium text-indigo-800 block">
                            Véhicule de livraison
                          </label>
                    
                          {loadingVehicules ? (
                            <p className="text-xs text-indigo-600 italic">⏳ Vérification disponibilité...</p>
                          ) : (
                            <>
                              {alerteVehicules && (
                                <div className={`p-2 rounded-md text-xs ${
                                  alerteVehicules.type === 'warning' 
                                    ? 'bg-amber-100 border border-amber-300 text-amber-800' 
                                    : 'bg-blue-100 border border-blue-300 text-blue-800'
                                }`}>
                                  <p className="font-semibold">{alerteVehicules.message}</p>
                                  {alerteVehicules.suggestion && (
                                    <p className="mt-1 italic">💡 Suggestion: {alerteVehicules.suggestion}</p>
                                  )}
                                </div>
                              )}
                        
                              <select
                                value={form.equipements_nacelle_vehicule_livraison_id || ''}
                                onChange={(e) => {
                                  const vehiculeId = e.target.value;
                                  const vehicule = vehiculesLivraison.find(v => v.id === vehiculeId);
                                  setForm(f => ({
                                    ...f,
                                    equipements_nacelle_vehicule_livraison_id: vehiculeId || null,
                                    equipements_nacelle_vehicule_livraison_nom: vehicule ? vehicule.nom : null
                                  }));
                                }}
                                className="w-full border border-indigo-300 rounded-md px-3 py-2 text-sm bg-white"
                                disabled={alerteVehicules?.type === 'warning'}
                              >
                                <option value="">-- Sélectionner un véhicule --</option>
                                {vehiculesLivraison.map(vehicule => (
                                  <option key={vehicule.id} value={vehicule.id}>
                                    {vehicule.nom} {vehicule.numero_unite ? `(${vehicule.numero_unite})` : ''} — Chef: {vehicule.chef_equipe_nom}
                                  </option>
                                ))}
                              </select>
                        
                              {vehiculesLivraison.length === 0 && !alerteVehicules && (
                                <p className="text-xs text-slate-500 italic">Aucun véhicule disponible pour la livraison</p>
                              )}
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  )}

                  {/* ✅ PHASE 2: ALERTE DISPONIBILITÉ NACELLE */}
                  {alerteNacelle && form.equipements_nacelle_id && (
                    <div className={`p-3 rounded-md border-2 ${
                      alerteNacelle.type === 'warning' 
                        ? 'bg-red-50 border-red-300' 
                        : 'bg-green-50 border-green-300'
                    }`}>
                      <p className={`text-sm font-semibold ${
                        alerteNacelle.type === 'warning' ? 'text-red-800' : 'text-green-800'
                      }`}>
                        {alerteNacelle.message}
                      </p>
                      {alerteNacelle.details && alerteNacelle.details.length > 0 && (
                        <div className="mt-2 space-y-1">
                          <p className="text-xs font-medium text-red-700">Détails des conflits:</p>
                          {alerteNacelle.details.map((conflit, idx) => (
                            <div key={conflit.id || conflit._id || idx} className="text-xs text-red-600 bg-red-100 p-1.5 rounded">
                              📅 {conflit.date} — {conflit.type} 
                              {conflit.client_nom && `: ${conflit.client_nom}`}
                              {conflit.chef_nom && ` (Chef: ${conflit.chef_nom})`}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}

                  {/* Sélection des dates + zones + notes */}
                  {form.equipements_nacelle_id && form.dates_chantier.length > 0 && (
                    <div className="border border-cyan-200 rounded-md p-3 bg-white">
                      <p className="text-sm font-semibold text-cyan-900 mb-2">
                        📅 Dates d'utilisation et positionnement
                      </p>
                      <div className="space-y-2">
                        {form.dates_chantier.map((dateStr, dateIdx) => {
                          const existingDate = (form.equipements_nacelle_dates || []).find(d => d.date === dateStr);
                          const isSelected = !!existingDate;
                    
                          return (
                            <div key={dateStr} className="flex items-start gap-2 p-2 hover:bg-cyan-50 rounded">
                              <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={(e) => {
                                  const newDates = [...(form.equipements_nacelle_dates || [])];
                                  if (e.target.checked) {
                                    newDates.push({ date: dateStr, zones_numeros: [], notes_positionnement: '' });
                                  } else {
                                    const idx = newDates.findIndex(d => d.date === dateStr);
                                    if (idx >= 0) newDates.splice(idx, 1);
                                  }
                                  setForm(f => ({ ...f, equipements_nacelle_dates: newDates }));
                                }}
                                className="w-4 h-4 mt-0.5 rounded border-cyan-300 text-cyan-600"
                              />
                              <div className="flex-1">
                                <span className="text-sm font-medium">
                                  {new Date(dateStr + 'T12:00:00').toLocaleDateString('fr-CA', { 
                                    weekday: 'short', day: 'numeric', month: 'short' 
                                  })}
                                </span>
                          
                                {/* Phase 5: Sélection de zone(s) + notes pour CHAQUE date */}
                                {isSelected && (
                                  <div className="mt-2 space-y-2 pl-2 border-l-2 border-cyan-200">
                                    <div>
                                      <label className="text-xs text-slate-600 block mb-1">
                                        Zone(s) de travail
                                      </label>
                                      {form.zones.length === 0 ? (
                                        <p className="text-[11px] text-slate-400 italic">Aucune zone définie</p>
                                      ) : (
                                        <div className="flex flex-wrap gap-1.5">
                                          {form.zones.map((z) => {
                                            const zNum = z.numero;
                                            const checked = (existingDate.zones_numeros || []).includes(zNum);
                                            return (
                                              <label
                                                key={zNum}
                                                className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-md border cursor-pointer text-xs transition ${
                                                  checked
                                                    ? 'bg-cyan-100 border-cyan-400 text-cyan-900'
                                                    : 'bg-white border-slate-200 text-slate-600 hover:bg-slate-50'
                                                }`}
                                              >
                                                <input
                                                  type="checkbox"
                                                  className="w-3 h-3 accent-cyan-600"
                                                  checked={checked}
                                                  onChange={(e) => {
                                                    const newDates = [...(form.equipements_nacelle_dates || [])];
                                                    const idx = newDates.findIndex(d => d.date === dateStr);
                                                    if (idx < 0) return;
                                                    const current = new Set(newDates[idx].zones_numeros || []);
                                                    if (e.target.checked) current.add(zNum);
                                                    else current.delete(zNum);
                                                    newDates[idx] = {
                                                      ...newDates[idx],
                                                      zones_numeros: [...current].sort((a, b) => a - b),
                                                    };
                                                    setForm(f => ({ ...f, equipements_nacelle_dates: newDates }));
                                                  }}
                                                  data-testid={`nacelle-zone-${dateStr}-${zNum}`}
                                                />
                                                Zone {zNum}: {z.nom}
                                              </label>
                                            );
                                          })}
                                        </div>
                                      )}
                                    </div>

                                    {dateIdx === 0 && (
                                      <div>
                                        <label className="text-xs text-slate-600 block mb-1">
                                          💡 Notes positionnement (1ère journée)
                                        </label>
                                        <textarea
                                          value={existingDate.notes_positionnement || ''}
                                          onChange={(e) => {
                                            const newDates = [...(form.equipements_nacelle_dates || [])];
                                            const idx = newDates.findIndex(d => d.date === dateStr);
                                            if (idx >= 0) {
                                              newDates[idx].notes_positionnement = e.target.value;
                                              setForm(f => ({ ...f, equipements_nacelle_dates: newDates }));
                                            }
                                          }}
                                          rows={2}
                                          placeholder="Ex: Placer la nacelle devant le garage, accès par la ruelle..."
                                          className="w-full border border-slate-300 rounded px-2 py-1 text-xs"
                                        />
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {/* Phase 4: Logistique retour */}
                  {(form.equipements_nacelle_dates || []).length > 0 && (
                    <div className="border-t border-cyan-200 pt-3 space-y-3">
                      <p className="text-sm font-semibold text-cyan-900">
                        🚚 Logistique de retour (dernière journée)
                      </p>
                
                      <div className="space-y-2">
                        <label className="flex items-center gap-2 cursor-pointer">
                          <input
                            type="radio"
                            name="nacelle_retour"
                            value="bureau"
                            checked={form.equipements_nacelle_retour_type === 'bureau'}
                            onChange={() => setForm(f => ({ 
                              ...f, 
                              equipements_nacelle_retour_type: 'bureau',
                              equipements_nacelle_client_livraison: null
                            }))}
                            className="text-cyan-600"
                          />
                          <span className="text-sm">🔙 Ramener la nacelle au bureau</span>
                        </label>
                  
                        <label className="flex items-center gap-2 cursor-pointer">
                          <input
                            type="radio"
                            name="nacelle_retour"
                            value="autre_chantier"
                            checked={form.equipements_nacelle_retour_type === 'autre_chantier'}
                            onChange={() => setForm(f => ({ ...f, equipements_nacelle_retour_type: 'autre_chantier' }))}
                            className="text-cyan-600"
                          />
                          <span className="text-sm">🚛 Livrer sur un autre chantier</span>
                        </label>
                      </div>

                      {/* Sélecteur de client pour livraison */}
                      {form.equipements_nacelle_retour_type === 'autre_chantier' && (
                        <div className="ml-6 p-3 bg-amber-50 border border-amber-200 rounded-md">
                          <label className="text-sm font-medium text-slate-700 block mb-2">
                            Client de livraison
                          </label>
                          <select
                            value={form.equipements_nacelle_client_livraison?.client_id || ''}
                            onChange={(e) => {
                              const clientId = e.target.value;
                              const client = clientsListe.find(c => c.id === clientId);
                              setForm(f => ({
                                ...f,
                                equipements_nacelle_client_livraison: client ? {
                                  client_id: client.id,
                                  client_nom: client.nom,
                                  adresse: `${client.adresse || ''}, ${client.ville || ''}`.trim()
                                } : null
                              }));
                            }}
                            className="w-full border border-amber-300 rounded-md px-3 py-2 text-sm bg-white"
                          >
                            <option value="">-- Sélectionner un client --</option>
                            {loadingClients ? (
                              <option disabled>Chargement...</option>
                            ) : (
                              clientsListe.map(client => (
                                <option key={client.id} value={client.id}>
                                  {client.nom} — {client.ville || 'Ville inconnue'}
                                </option>
                              ))
                            )}
                          </select>
                    
                          {form.equipements_nacelle_client_livraison && (
                            <div className="mt-2 p-2 bg-white rounded border border-amber-200">
                              <p className="text-xs font-semibold text-slate-700">Adresse de livraison:</p>
                              <p className="text-xs text-slate-600 mt-0.5">
                                {form.equipements_nacelle_client_livraison.adresse || 'Adresse non disponible'}
                              </p>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* ───────────────────────────────────────────────────────────── */}
            {/* SECTION DÉMONTAGE ÉCHAFAUDS (si cochés dans Lavage à pression) */}
            {/* ───────────────────────────────────────────────────────────── */}
            {form.echafauds_a_monter && (
              <div className="border-2 border-orange-200 rounded-lg p-4 bg-orange-50/30">
                <div className="flex items-start gap-3">
                  <div className="flex-1">
                    <p className="text-base font-semibold text-orange-900">
                      🔧 Démontage des échafauds
                    </p>
                    <p className="text-xs text-orange-700 mt-0.5">
                      Échafauds cochés dans "Lavage à pression à faire"
                    </p>
                  </div>
                </div>

                {form.dates_chantier.length > 0 && (
                  <div className="mt-4 space-y-4 pl-2">
                    {/* Date de démontage */}
                    <div>
                      <label className="text-sm font-medium text-orange-900 mb-1.5 block">
                        📅 Date de démontage
                      </label>
                      <input
                        type="date"
                        value={form.echafauds_date_demontage || ''}
                        onChange={(e) => setForm(f => ({ ...f, echafauds_date_demontage: e.target.value }))}
                        className="w-full border border-orange-300 rounded-md px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-orange-400"
                      />
                      <p className="text-xs text-orange-600 mt-1 italic">
                        💡 Choisissez la date où les échafauds seront démontés et la remorque récupérée
                      </p>
                    </div>

                    {/* Emplacement de la remorque */}
                    {form.echafauds_date_demontage && (
                      <div className="border-t border-orange-200 pt-3">
                        <p className="text-sm font-semibold text-orange-900 mb-2">
                          🚚 Emplacement de la remorque
                        </p>
                  
                        {form.echafauds_remorque_retour === 'bureau' ? (
                          <div className="p-3 bg-blue-50 border border-blue-200 rounded-md">
                            <p className="text-sm font-medium text-blue-800 flex items-center gap-2">
                              🏢 Prendre la remorque au bureau
                            </p>
                            <p className="text-xs text-blue-600 mt-1">
                              Le matin du démontage ({form.echafauds_date_demontage ? new Date(form.echafauds_date_demontage + 'T12:00:00').toLocaleDateString('fr-CA', { weekday: 'long', day: 'numeric', month: 'long' }) : ''}), 
                              l'équipe doit passer au bureau pour récupérer la remorque.
                            </p>
                          </div>
                        ) : (
                          <div className="p-3 bg-green-50 border border-green-200 rounded-md">
                            <p className="text-sm font-medium text-green-800 flex items-center gap-2">
                              📍 Remorque déjà chez le client
                            </p>
                            <p className="text-xs text-green-600 mt-1">
                              La remorque est restée chez le client depuis le montage. L'équipe peut aller directement sur place pour le démontage.
                            </p>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {form.dates_chantier.length === 0 && (
                  <p className="text-xs text-amber-600 mt-3 italic">
                    ⚠️ Veuillez d'abord sélectionner des dates de chantier ci-dessus
                  </p>
                )}
              </div>
            )}

            {/* ───────────────────────────────────────────────────────────── */}
            {/* PHASE 2: ÉCHAFAUDS INDÉPENDANTS */}
            {/* ───────────────────────────────────────────────────────────── */}
            <div className="border-2 border-orange-200 rounded-lg p-4 bg-orange-50/30">
              <label className="flex items-center gap-3 cursor-pointer group">
                <input
                  type="checkbox"
                  checked={form.equipements_echafauds_requis || false}
                  onChange={(e) => {
                    setForm(f => ({
                      ...f,
                      equipements_echafauds_requis: e.target.checked,
                      equipements_echafauds_utilises: e.target.checked ? f.equipements_echafauds_utilises : []
                    }));
                  }}
                  className="w-5 h-5 rounded border-orange-300 text-orange-600 focus:ring-orange-400"
                />
                <div className="flex-1">
                  <span className="text-base font-semibold text-orange-900 group-hover:text-orange-700">
                    🔧 Échafauds à monter
                  </span>
                  <p className="text-xs text-orange-700 mt-0.5">
                    Indépendant du lavage à pression
                  </p>
                </div>
              </label>

              {form.equipements_echafauds_requis && (
                <div className="mt-4 space-y-3 pl-8">
                  {/* Réutiliser la logique multi-types */}
                  <p className="text-sm font-semibold text-orange-800">
                    Sélectionnez les types d'échafauds nécessaires:
                  </p>
            
                  {typesEchafauds.length === 0 ? (
                    <p className="text-xs text-orange-600 italic">
                      ⚠️ Aucun type d'échafaud configuré dans l'inventaire
                    </p>
                  ) : (
                    <div className="space-y-2">
                      {typesEchafauds.map((typeEchafaud, idx) => {
                        const echafaudSelectionne = (form.equipements_echafauds_utilises || []).find(
                          e => e.type === typeEchafaud.type && e.dimensions === typeEchafaud.dimensions
                        );
                        const quantite = echafaudSelectionne?.quantite || 0;
                        const isChecked = !!echafaudSelectionne;

                        return (
                          <div key={idx} className="flex items-center gap-3 p-2 bg-white rounded-md border border-orange-100 hover:border-orange-300 transition-colors">
                            <input
                              type="checkbox"
                              checked={isChecked}
                              onChange={e => {
                                const newList = [...(form.equipements_echafauds_utilises || [])];
                                if (e.target.checked) {
                                  newList.push({ type: typeEchafaud.type, dimensions: typeEchafaud.dimensions, quantite: 1 });
                                } else {
                                  const findIdx = newList.findIndex(item => item.type === typeEchafaud.type && item.dimensions === typeEchafaud.dimensions);
                                  if (findIdx >= 0) newList.splice(findIdx, 1);
                                }
                                setForm(f => ({ ...f, equipements_echafauds_utilises: newList }));
                              }}
                              className="w-4 h-4 rounded border-orange-300 text-orange-600"
                            />
                      
                            <div className="flex-1">
                              <span className="text-sm font-medium text-orange-800">
                                {typeEchafaud.type} - {typeEchafaud.dimensions}
                              </span>
                              <span className="text-xs text-orange-600 ml-2">
                                ({typeEchafaud.quantite_totale} dispo)
                              </span>
                            </div>
                      
                            {isChecked && (
                              <div className="flex items-center gap-2">
                                <label className="text-xs text-orange-700 font-medium">Qté:</label>
                                <input
                                  type="number"
                                  min="1"
                                  value={quantite}
                                  onChange={e => {
                                    const newList = [...(form.equipements_echafauds_utilises || [])];
                                    const findIdx = newList.findIndex(item => item.type === typeEchafaud.type && item.dimensions === typeEchafaud.dimensions);
                                    if (findIdx >= 0) {
                                      newList[findIdx].quantite = parseInt(e.target.value) || 1;
                                      setForm(f => ({ ...f, equipements_echafauds_utilises: newList }));
                                    }
                                  }}
                                  className="w-16 border border-orange-200 rounded px-2 py-1 text-sm"
                                />
                                <span className="text-xs text-orange-600">étages</span>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {/* Résumé */}
                  {(form.equipements_echafauds_utilises || []).length > 0 && (
                    <div className="p-2 bg-orange-100 rounded-md">
                      <p className="text-xs font-semibold text-orange-800">
                        📊 Total : {(form.equipements_echafauds_utilises || []).reduce((sum, e) => sum + (e.quantite || 0), 0)} étages
                        ({(form.equipements_echafauds_utilises || []).length} type(s))
                      </p>
                    </div>
                  )}

                  {/* Phase 5: Zones pour échafauds */}
                  {(form.equipements_echafauds_utilises || []).length > 0 && form.zones.length > 0 && (
                    <div className="border-t border-orange-200 pt-3 mt-3">
                      <p className="text-sm font-semibold text-orange-900 mb-2">
                        🗺️ Zones de travail avec échafauds (Phase 5)
                      </p>
                      <div className="flex flex-wrap gap-2">
                        {form.zones.map((zone, zIdx) => {
                          const isSelected = (form.equipements_echafauds_zones || []).includes(zone.numero);
                          return (
                            <label key={zIdx} className="flex items-center gap-1.5 cursor-pointer">
                              <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={(e) => {
                                  const newZones = [...(form.equipements_echafauds_zones || [])];
                                  if (e.target.checked) {
                                    newZones.push(zone.numero);
                                  } else {
                                    const idx = newZones.indexOf(zone.numero);
                                    if (idx >= 0) newZones.splice(idx, 1);
                                  }
                                  setForm(f => ({ ...f, equipements_echafauds_zones: newZones }));
                                }}
                                className="w-3.5 h-3.5 rounded border-orange-300 text-orange-600"
                              />
                              <span className="text-xs">Zone {zone.numero}</span>
                            </label>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>

          </CardContent>
        </Card>
      )}

    </>
  );
}
